/**
 * seo/pages.js — Bar Experts
 * Título, descrição e imagem de prévia de cada página pública (S09).
 *
 * Usado em dois lugares:
 * 1. No build (vite.config.js): gera dist/<página>/index.html com estes metadados
 *    já no HTML, para WhatsApp/Instagram/Facebook (eles NÃO rodam JavaScript).
 * 2. No navegador (seo/applyMeta.js): atualiza os metadados ao trocar de página.
 *
 * Página pública nova = adicionar aqui. Descrição: até 160 caracteres, sem emoji.
 */
export const SITE_URL = 'https://barexperts.com.br'
export const IMG_BRAND = '/images/og-barexperts.jpg'
export const IMG_CHAMPIONSHIP = '/images/og-championship.jpg'

export const DEFAULT_PAGE = {
  title: 'Bar Experts — Coquetelaria, Cursos e Masterclasses',
  description: 'Biblioteca de coquetelaria, cursos, masterclasses e o Campeonato Off Z Wagon da Caos Bar Experts.',
  image: IMG_BRAND,
}

export const PAGES = {
  '/': {
    title: '2º Campeonato Off Z Wagon — O Desafio Proibicionista | Bar Experts',
    description: 'A maior disputa de coquetelaria autoral, criatividade e hospitalidade está declarada. Confira o regulamento e inscreva-se.',
    image: IMG_CHAMPIONSHIP,
  },
  '/campeonato': {
    title: 'Dossiê Clandestino — 2º Campeonato Off Z Wagon | Bar Experts',
    description: 'Fichas técnicas, briefing e prazos do 2º Campeonato Off Z Wagon. Inscreva seu coquetel autoral e dispute mais de R$ 4.000 em prêmios.',
    image: IMG_CHAMPIONSHIP,
  },
  '/regulamento': {
    title: 'Regulamento Oficial — 2º Campeonato Off Z Wagon | Bar Experts',
    description: 'Critérios de julgamento, pontuação, prazos e premiação do 2º Campeonato Off Z Wagon de coquetelaria autoral.',
    image: IMG_CHAMPIONSHIP,
  },
  '/regulamento-interno': {
    title: 'Guia Operacional & Mentoria — Off Z Wagon',
    description: 'Área restrita ao staff do campeonato.',
    image: IMG_CHAMPIONSHIP,
    noindex: true,
  },
  '/biblioteca': {
    title: 'Biblioteca Pública & Literatura de Bar — Bar Experts',
    description: 'Literatura clássica de bar em domínio público, livros históricos e manuais pedagógicos de coquetelaria.',
    image: IMG_BRAND,
  },
  '/coqueteis': {
    title: 'Coquetéis Clássicos & Fichas Técnicas — Bar Experts',
    description: 'Fórmulas canônicas mundiais da IBA, TheCocktailDB e livros clássicos com dosagens e métodos de preparo.',
    image: IMG_BRAND,
  },
  '/biblioteca/apostilas': {
    title: 'Apostilas & Materiais de Estudo — Bar Experts',
    description: 'Cadernos pedagógicos dos cursos Iniciante e Avançado de coquetelaria da Bar Experts.',
    image: IMG_BRAND,
  },
  '/cursos': {
    title: 'Cursos de Bartender e Coquetelaria — Bar Experts',
    description: 'Cursos, workshops e oficinas presenciais de coquetelaria da Caos Bar Experts, com datas, locais, valores e inscrição.',
    image: IMG_BRAND,
  },
  '/masterclass': {
    title: 'Masterclasses de Coquetelaria — Bar Experts',
    description: 'Masterclasses com bartenders convidados: técnicas de bar, pré-batch, destilados e serviço.',
    image: IMG_BRAND,
  },
  '/magazine': {
    title: 'Magazine — Em breve | Bar Experts',
    description: 'A revista digital de coquetelaria da Bar Experts está chegando.',
    image: IMG_BRAND,
  },
  '/privacidade': {
    title: 'Política de Privacidade — Bar Experts',
    description: 'Como a Bar Experts coleta, usa e protege seus dados pessoais, de acordo com a LGPD.',
    image: IMG_BRAND,
  },
  '/termos': {
    title: 'Termos de Uso — Bar Experts',
    description: 'Termos e condições de uso do portal Bar Experts.',
    image: IMG_BRAND,
  },
  '/login': {
    title: 'Entrar — Bar Experts',
    description: 'Acesse sua conta Bar Experts.',
    image: IMG_BRAND,
    noindex: true,
  },
}

/** Metadados de uma rota (página exata; senão o padrão com o título da rota). */
export function pageMeta(path, fallbackTitle) {
  const clean = (path || '/').replace(/\/+$/, '') || '/'
  const page = PAGES[clean]
  if (page) return { ...DEFAULT_PAGE, ...page, path: clean }
  return { ...DEFAULT_PAGE, title: fallbackTitle || DEFAULT_PAGE.title, path: clean }
}
